module.exports = "<div class=\"container d-flex flex-column\">\r\n  <app-welcome></app-welcome>\r\n  <app-aims-scope></app-aims-scope>\r\n  <div class=\"d-xl-flex flex-xl-row align-content-lg-start\">\r\n    <app-scientific-committee></app-scientific-committee>\r\n    <app-organizers></app-organizers>\r\n  </div>\r\n  <app-plenary-speakers></app-plenary-speakers>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main